import React, { useEffect, useState } from 'react';
import { Button, Box } from '@mui/material';
import BigBus from '../components/bus/bigBus';
import Limousine from '../components/bus/limousine';
import SmallBus from '../components/bus/smallBus';
import BusNotice from '../components/bus/busNotice';

const Bus = () => {
  const [busState, setBusState] = useState('notice');

  useEffect(() => {
    const titleElement = document.querySelector("title");
    titleElement.innerHTML = `이케이하나관광-버스안내`;
  }, []);

  const handleChangeMode = (mode) => setBusState(mode);

  function BusButton(props) {
    const selected = busState === props.mode;

    return (
      <Button
      onClick={props.buttonClick}
      variant='contained'
      sx={{
        /* 모바일에선 원형이 글자를 못 담아 알약형으로 바꾼다 */
        width: {xs: 'auto', md: '6.8em'},
        minWidth: 0,
        height: {xs: 'auto', md: '6em'},
        px: {xs: 1.6, md: 1},
        py: {xs: 0.8, md: 1},
        fontSize: {xs: 13, md: 14},
        lineHeight: 1.3,
        fontWeight: 700,
        wordBreak: 'keep-all',
        color: '#5A4231',
        borderRadius: {xs: '999px', md: '50%'},
        m: {xs: '4px', md: '40px 10px'},
        boxShadow: 'none',
        backgroundColor: selected ? '#FFFACB' : '#D3D3D3',
        transition: '0.5s',
        '&:hover': {
          backgroundColor: '#FFFACB',
          transform: 'scale(1.02)'
        }
      }}>
        {props.buttonText}
      </Button>
    )
  }

  return (
    <>
      <Box sx={{
        textAlign: 'center',
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'center',
        px: {xs: 1.5, md: 0},
        pt: {xs: 2, md: 0},
      }}>
        <BusButton
        buttonText='버스 안내'
        mode='notice'
        buttonClick={() => handleChangeMode('notice')} />
        <BusButton
        buttonText='25인승 소형'
        mode='smallBus'
        buttonClick={() => handleChangeMode('smallBus')} />
        <BusButton
        buttonText='28인승 대형 리무진'
        mode='limousine'
        buttonClick={() => handleChangeMode('limousine')} />
        <BusButton
        buttonText='45인승 대형'
        mode='bigBus'
        buttonClick={() => handleChangeMode('bigBus')} />
      </Box>

      {busState === 'notice' && <BusNotice />}

      {busState === 'smallBus' && <SmallBus />}

      {busState === 'limousine' && <Limousine />}

      {busState === 'bigBus' && <BigBus />}
    </>
  )
};

export default Bus;